import { jsx } from 'react/jsx-runtime';
import { ExclamationmarkOctagonIcon } from '@flex-design-system/legacy-flex-icons';
import { useId } from '@radix-ui/react-id';
import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import { useMemo } from 'react';
import { HelperText } from '../../helper-text/HelperText.mjs';

function BaseHelperText({
  icon: iconFromProps,
  children,
  id,
  state,
  setDescribedBy,
  ...props
}) {
  const helperTextId = useId(id);
  useLayoutEffect(() => {
    setDescribedBy(helperTextId);
  }, [helperTextId, setDescribedBy]);
  const icon = useMemo(() => {
    return state === "error" ? /* @__PURE__ */ jsx(ExclamationmarkOctagonIcon, { type: "fill", color: "orange" }) : iconFromProps;
  }, [iconFromProps, state]);
  return /* @__PURE__ */ jsx(HelperText, { leftSlot: icon, id: helperTextId, state, ...props, children });
}

export { BaseHelperText as default };
//# sourceMappingURL=BaseHelperText.mjs.map
